import FootballTransition from "../../football/state/football-transition";
import FootballState from "../../football/state/football-state";

const FlagFootballTransitionConfig = [
    {
        name: FootballTransition.Spike,
        from: [FootballState.AddPlay, FootballState.FumbledSnap],
        to: FootballState.Spike
    },
    {
        name: FootballTransition.KneelDown,
        from: [FootballState.AddPlay],
        to: FootballState.KneelDown
    },
    // Fumbled Snap. Flag does not use football's Recovered/Lost outcomes: the
    // ball is dead the moment it grounds, so the snap is a marker and the crew
    // records what actually happened next via Rush, Pass, Fumble or Spike.
    {
        name: FootballTransition.FumbledSnap,
        from: [FootballState.AddPlay],
        to: FootballState.FumbledSnap
    },
    // Dead Ball. Only from a fumbled snap, and only offered when fumbles are
    // gated off (see FlagFootballService._hideApplicableTransitions): the ball
    // grounded, nobody recovered it, the play is over where it lies. When
    // fumbles are available the Fumble path is the richer record and this is
    // not offered, so there is never more than one way to enter the play.
    {
        name: FootballTransition.DeadBall,
        from: [FootballState.FumbledSnap],
        to: FootballState.DeadBall
    },
    {
        name: FootballTransition.AddPlay,
        from: FootballState.Start,
        to: FootballState.AddPlay
    },
    {
        name: FootballTransition.Rush,
        from: [FootballState.AddPlay, FootballState.FumbledSnap],
        to: FootballState.Rush
    },
    {
        name: FootballTransition.EndOfPlay,
        from: [
            FootballState.Rush,
            FootballState.Fumble,
            FootballState.DeadBall,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.Tackle,
            FootballState.Safety,
            FootballState.OutOfBounds,
            FootballState.PatBlocked,
            FootballState.PatCompleted,
            FootballState.PatMissed,
            FootballState.PatIntercepted,
            FootballState.PatFumbled,
            FootballState.Rouge,
            FootballState.Downed,
            FootballState.TouchBack,
            FootballState.FairCatch,
            FootballState.OnSide,
            FootballState.PassIntercepted,
            FootballState.PassComplete,
            FootballState.PassIncomplete,
            FootballState.PassBrokenUp,
            FootballState.PassDropped,
            FootballState.PassSacked,
            FootballState.PenaltyDeclined,
            FootballState.NoPlay,
            FootballState.PuntOutOfBounds,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.NoRecoveryKickReturn,
            FootballState.Lateral,
            FootballState.Spike,
            FootballState.KneelDown
        ],
        to: FootballState.EndOfPlay
    },
    {
        name: FootballTransition.StatsCountYes,
        from: FootballState.StatsCount,
        to: FootballState.EndOfPlay
    },
    {
        // TODO: Is this correct? Going from penalty accepted to NoPenaltyEndOfPlay
        name: FootballTransition.NoPenaltyEndOfPlay,
        from: [
            FootballState.PlayPenaltyPenaltyAccepted,
            FootballState.PlayPenaltyPenaltyDeclined,
            FootballState.PlayPenaltyStatsCount,
            FootballState.PlayPenaltyNoPlay
        ],
        to: FootballState.NoPenaltyEndOfPlay
    },
    {
        name: FootballTransition.OutOfBounds,
        from: [
            FootballState.Rush,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.KickOff,
            FootballState.PassComplete,
            FootballState.PassIntercepted,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.NoRecoveryKickReturn,
            FootballState.Lateral
        ],
        to: FootballState.OutOfBounds
    },
    {
        name: FootballTransition.FumbleRecovered,
        from: FootballState.Fumble,
        to: FootballState.FumbleRecovered
    },
    {
        name: FootballTransition.FumbleNotRecovered,
        from: FootballState.Fumble,
        to: FootballState.FumbleNotRecovered
    },
    {
        name: FootballTransition.Fumble,
        from: [
            FootballState.Rush,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.PassComplete,
            FootballState.Pass,
            FootballState.PassSacked,
            FootballState.PassIntercepted,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.NoRecoveryKickReturn,
            FootballState.Lateral,
            FootballState.FumbledSnap
        ],
        to: FootballState.Fumble
    },
    {
        name: FootballTransition.Tackle,
        from: [
            FootballState.Rush,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.PassComplete,
            FootballState.PassIntercepted,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.NoRecoveryKickReturn,
            FootballState.Lateral
        ],
        to: FootballState.Tackle
    },
    {
        name: FootballTransition.Continue,
        from: [
            FootballState.PassComplete,
            FootballState.KickRecovered,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Lateral
        ],
        to: FootballState.Continue
    },
    {
        name: FootballTransition.Returned,
        from: [FootballState.KickOff, FootballState.Punt],
        to: FootballState.Returned
    },
    {
        name: FootballTransition.NoRecoveryKickReturn,
        from: FootballState.KickNotRecovered,
        to: FootballState.NoRecoveryKickReturn
    },
    {
        name: FootballTransition.Finalize,
        from: [
            FootballState.EndOfPlay,
            FootballState.NoPenaltyEndOfPlay,
            FootballState.Timeout,
            FootballState.StartDrive,
            FootballState.GameStart,
            FootballState.StartPeriod,
            FootballState.UpdateContext,
            FootballState.CoinToss,
            FootballState.SetTimeAndPeriod
        ],
        to: FootballState.Finalize
    },
    //PENALTIES
    {
        name: FootballTransition.Penalty,
        from: FootballState.EndOfPlay,
        to: FootballState.Penalty
    },
    {
        name: FootballTransition.PenaltyDeclined,
        from: [FootballState.Penalty, FootballState.SecondPenalty],
        to: FootballState.PenaltyDeclined
    },
    {
        name: FootballTransition.PenaltyAccepted,
        from: [FootballState.Penalty, FootballState.SecondPenalty],
        to: FootballState.PenaltyAccepted
    },
    {
        name: FootballTransition.Offsetting,
        from: FootballState.Penalty,
        to: FootballState.Offsetting
    },
    {
        name: FootballTransition.SecondOffsetting,
        from: FootballState.SecondPenalty,
        to: FootballState.SecondOffsetting
    },
    {
        name: FootballTransition.SecondPenalty,
        from: FootballState.Offsetting,
        to: FootballState.SecondPenalty
    },
    {
        name: FootballTransition.StatsCount,
        from: [FootballState.PenaltyAccepted, FootballState.SecondOffsetting],
        to: FootballState.StatsCount
    },
    {
        name: FootballTransition.NoPlay,
        from: FootballState.StatsCount,
        to: FootballState.NoPlay
    },
    //PLAY PENALTIES
    {
        name: FootballTransition.PlayPenalty,
        from: [FootballState.AddPlay],
        to: FootballState.PlayPenalty
    },
    {
        name: FootballTransition.PlayPenaltyPenaltyDeclined,
        from: [
            FootballState.PlayPenalty,
            FootballState.PlayPenaltySecondPenalty
        ],
        to: FootballState.PlayPenaltyPenaltyDeclined
    },
    {
        name: FootballTransition.PlayPenaltyPenaltyAccepted,
        from: [
            FootballState.PlayPenalty,
            FootballState.PlayPenaltySecondPenalty
        ],
        to: FootballState.PlayPenaltyPenaltyAccepted
    },
    {
        name: FootballTransition.PlayPenaltyOffsetting,
        from: FootballState.PlayPenalty,
        to: FootballState.PlayPenaltyOffsetting
    },
    {
        name: FootballTransition.PlayPenaltySecondOffsetting,
        from: FootballState.PlayPenaltySecondPenalty,
        to: FootballState.PlayPenaltySecondOffsetting
    },
    {
        name: FootballTransition.PlayPenaltySecondPenalty,
        from: FootballState.PlayPenaltyOffsetting,
        to: FootballState.PlayPenaltySecondPenalty
    },
    {
        name: FootballTransition.PlayPenaltyNoPlay,
        from: FootballState.PlayPenaltyStatsCount,
        to: FootballState.PlayPenaltyNoPlay
    },
    {
        name: FootballTransition.PlayPenaltyStatsCount,
        from: FootballState.PlayPenaltySecondOffsetting,
        to: FootballState.PlayPenaltyStatsCount
    },
    //PAT
    {
        name: FootballTransition.PatTry,
        from: FootballState.AddPlay,
        to: FootballState.PatTry
    },
    {
        name: FootballTransition.PatPass,
        from: FootballState.PatTry,
        to: FootballState.PatPass
    },
    {
        name: FootballTransition.Run,
        from: FootballState.PatTry,
        to: FootballState.Run
    },
    {
        name: FootballTransition.PatCompleted,
        from: [FootballState.PatPass, FootballState.Run],
        to: FootballState.PatCompleted
    },
    {
        name: FootballTransition.PatMissed,
        from: [FootballState.PatPass, FootballState.Run],
        to: FootballState.PatMissed
    },
    {
        name: FootballTransition.Downed,
        from: [FootballState.KickOff, FootballState.Punt],
        to: FootballState.Downed
    },
    {
        name: FootballTransition.TouchBack,
        from: [FootballState.KickOff, FootballState.Punt, FootballState.Fumble],
        to: FootballState.TouchBack
    },
    {
        name: FootballTransition.FairCatch,
        from: [FootballState.KickOff, FootballState.Punt],
        to: FootballState.FairCatch
    },
    {
        name: FootballTransition.OnSide,
        from: FootballState.KickOff,
        to: FootballState.OnSide
    },
    //KICKOFF
    {
        name: FootballTransition.Kick,
        from: FootballState.AddPlay,
        to: FootballState.Kick
    },
    {
        name: FootballTransition.KickOff,
        from: FootballState.Kick,
        to: FootballState.KickOff
    },
    //PUNT
    {
        name: FootballTransition.Punt,
        from: FootballState.AddPlay,
        to: FootballState.Punt
    },
    {
        name: FootballTransition.PuntOutOfBounds,
        from: FootballState.Punt,
        to: FootballState.PuntOutOfBounds
    },
    {
        name: FootballTransition.PuntBlocked,
        from: FootballState.Punt,
        to: FootballState.PuntBlocked
    },
    {
        name: FootballTransition.KickRecovered,
        from: [FootballState.PuntBlocked, FootballState.OnSide],
        to: FootballState.KickRecovered
    },
    {
        name: FootballTransition.KickNotRecovered,
        from: [FootballState.PuntBlocked, FootballState.OnSide],
        to: FootballState.KickNotRecovered
    },
    //PASS
    {
        name: FootballTransition.Pass,
        from: [FootballState.AddPlay, FootballState.FumbledSnap],
        to: FootballState.Pass
    },
    {
        name: FootballTransition.PassIncomplete,
        from: FootballState.Pass,
        to: FootballState.PassIncomplete
    },
    {
        name: FootballTransition.PassBrokenUp,
        from: FootballState.Pass,
        to: FootballState.PassBrokenUp
    },
    {
        name: FootballTransition.PassDropped,
        from: FootballState.Pass,
        to: FootballState.PassDropped
    },
    {
        name: FootballTransition.PassSacked,
        from: FootballState.Pass,
        to: FootballState.PassSacked
    },
    {
        name: FootballTransition.PassIntercepted,
        // PatPass: a try can be intercepted and returned (gated per event by
        // general.defensivePatReturnEnabled in FlagFootballService).
        from: [FootballState.Pass, FootballState.PatPass],
        to: FootballState.PassIntercepted
    },
    {
        name: FootballTransition.PassComplete,
        from: FootballState.Pass,
        to: FootballState.PassComplete
    },
    //GAME CONTROL
    {
        name: FootballTransition.GameControl,
        from: FootballState.AddPlay,
        to: FootballState.GameControl
    },
    {
        name: FootballTransition.StartDrive,
        from: FootballState.GameControl,
        to: FootballState.StartDrive
    },
    {
        name: FootballTransition.Timeout,
        from: FootballState.GameControl,
        to: FootballState.Timeout
    },
    {
        name: FootballTransition.GameStart,
        from: FootballState.GameControl,
        to: FootballState.GameStart
    },
    {
        name: FootballTransition.StartPeriod,
        from: FootballState.GameControl,
        to: FootballState.StartPeriod
    },
    {
        name: FootballTransition.UpdateContext,
        from: FootballState.GameControl,
        to: FootballState.UpdateContext
    },
    {
        name: FootballTransition.CoinToss,
        from: FootballState.GameControl,
        to: FootballState.CoinToss
    },
    {
        name: FootballTransition.SwapTeams,
        from: FootballState.GameControl,
        to: FootballState.SwapTeams
    },
    {
        name: FootballTransition.Lateral,
        from: [
            FootballState.Continue,
            FootballState.PassIntercepted,
            FootballState.PatIntercepted,
            FootballState.Rush,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn
        ],
        to: FootballState.Lateral
    },
    {
        name: FootballTransition.Safety,
        from: [
            FootballState.Tackle,
            FootballState.OutOfBounds,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.PassSacked,
            FootballState.Continue,
            // A fumble is a dead ball where it grounds; dead in the
            // offense's own end zone it is a safety. A Dead Ball is the same
            // event recorded without a fumble, so it carries the same case -
            // otherwise gating fumbles would make it unrecordable.
            FootballState.Fumble,
            FootballState.DeadBall
        ],
        to: FootballState.Safety
    },
    {
        name: FootballTransition.SetTimeAndPeriod,
        from: FootballState.GameControl,
        to: FootballState.SetTimeAndPeriod
    }
];

export default FlagFootballTransitionConfig;
